export const getUniqueArray = <T extends string | number>(
  data?: Array<T | undefined>
): T[] => {
  if (!data) {
    return []
  }

  const values = data.filter((item) => item !== undefined) as T[]
  const set = new Set<T>(values)

  return Array.from(set)
}
